import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";

import { IppyDippyCrudModel } from "./IppyDippyCrudModel";

export class QuizQuestion extends IppyDippyCrudModel {
  protected static _typeLabel = "Question";
  protected static _typeLabelPlural = "Questions";
  protected static asProperty = "quiz_question";
  public static api = {
    path: "quiz-questions",
  };
  protected static routeBase = "quiz-questions";
  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.SuperUser]: UserPermission.Edit,
    },
    UserPermission.Read
  );

  protected userIdField = [];

  protected static propertyDefinitions = [
    {
      type: "NumberProperty",
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "created_at",
        displayRelative: true,
        label: "Entry Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "updated_at",
        displayRelative: true,
        label: "Entry Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "deleted_at",
        displayRelative: true,
        label: "Entry Deleted At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "StringProperty",
      opts: {
        name: "question",
        label: "Question",
        rules: ["required"],
      },
    },
    {
      type: "NumberProperty",
      opts: {
        name: "num_answers",
        label: "Number of Answers to Offer",
      },
    },
    {
      type: "RelationshipProperty",
      opts: {
        name: "content",
        label: "For Content",
        relatedModel: "Content",
        foreignProperty: "questions",
        computed: true,
      },
    },
    {
      type: "RelationshipPropertyMany",
      opts: {
        name: "quiz_answers",
        label: "Answers",
        relatedModel: "QuizAnswer",
        foreignProperty: "quiz_question",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: "NumberField", opts: { property: "id" } },
    {
      type: "DateTimeField",
      opts: { property: "created_at" },
    },
    { type: "DateTimeField", opts: { property: "updated_at" } },
    { type: "DateTimeField", opts: { property: "deleted_at" } },
    {
      type: "LongTextField",
      opts: { property: "question", isPrimaryLabelField: true, cols: 12 },
    },

    { type: "NumberField", opts: { property: "num_answers" } },
    {
      type: "RelationshipFieldMany",
      opts: {
        property: "quiz_answers",
        viewComponentName: "view-relationship-field-many-labels",
        formComponentName: "form-relationship-field-many-table",
        cols: 12,
        collectionLayoutOpts: {
          columnFields: ["answer", "weight"],
          enableSearch: false,
          noRefresh: true,
          cols: 12,
        },
      },
    },
    {
      type: "RelationshipField",
      opts: {
        property: "content",
      },
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      id: "Crudform",
      fieldSets: [
        {
          id: "0",
          fields: ["question", "num_answers", "quiz_answers"],
        },
        {
          id: "1",
          fields: ["content", "created_at", "updated_at"],
        },
      ],
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["question", "num_answers", "content"],
      enableSearch: true,
      enableDynamicFilters: true,
      noNew: true,
      dynamicFilterOptions: {
        filterFields: ["question", "num_answers", "quiz_answers", "content"],
      },
      defaultSort: [
        {
          field: "question",
          order: "asc",
        },
      ],
      expansionComponent: {
        name: "ModelLayoutExpansion",
      },
    },
  ];
}
